import { render } from "./RegisterProfile.vue?vue&type=template&id=9943ead4&scoped=true"
import script from "./RegisterProfile.js?vue&type=script&lang=js"
export * from "./RegisterProfile.js?vue&type=script&lang=js"

import "./RegisterProfile.scss?vue&type=style&index=0&id=9943ead4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9943ead4"]])

export default __exports__